
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow-download': {
    width: 20,
    height: 20,
    viewBox: '0 0 14 17',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M10 6H11.59C12.48 6 12.92 7.08 12.29 7.71L7.7 12.3C7.31 12.69 6.68 12.69 6.29 12.3L1.7 7.71C1.07 7.08 1.52 6 2.41 6H4V1C4 0.45 4.45 0 5 0H9C9.55 0 10 0.45 10 1V6ZM1 17C0.45 17 0 16.55 0 16C0 15.45 0.45 15 1 15H13C13.55 15 14 15.45 14 16C14 16.55 13.55 17 13 17H1Z" fill="#2DCCAC"/>'
  }
})
